const routes = [
    {
        path: "/announcements",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission:'announcement_index'
        }
    }
];

export default routes;
